<template>
  <div>
    <v-container grid-list-md fluid>
      <v-layout row wrap>
        <v-flex md6 xs12 d-flex>
          <v-card>
            <v-card-title class="pb-0">
              <v-layout align-center justify-space-between fill-height>
                <v-flex xs7>
                  <h5 class="headline text-uppercase text-green">{{ 'app.patient_information.basic_information' | trans }}</h5>
                </v-flex>
                <v-flex xs5>
                  <patient-manage-modal :edit-mode="true"/>
                </v-flex>
              </v-layout>
            </v-card-title>
            <v-card-text class="pt-0">
              <v-divider></v-divider>
              <v-layout wrap>
                <v-flex xs12>
                  <h5 class="subheading">{{ 'app.first_name_and_last_name'|trans }}</h5>
                  <span>{{ `${patient.first_name} ${patient.last_name}` }}</span>
                </v-flex>
                <v-flex xs6>
                  <h5 class="mt-4 subheading">{{ 'app.age'|trans }}</h5>
                  <span>{{ `${patient.age} ${getAge(patient.age)}` }}</span>
                </v-flex>
                <v-flex xs6>
                  <h5 class="mt-4 subheading">{{ 'app.sex'|trans }}</h5>
                  <span>{{ getSex() }}</span>
                </v-flex>
                <v-flex xs6>
                  <h5 class="mt-4 subheading">{{ 'app.phone_number'|trans }}</h5>
                  <span>{{ patient.phone_number }}</span>
                  <span v-if="patient.phone_number === null">{{ `app.no_data`|trans }}</span>
                </v-flex>
                <v-flex xs6>
                  <h5 class="mt-4 subheading">{{ 'app.email'|trans }}</h5>
                  <span>{{ patient.email }}</span>
                  <span v-if="patient.email === null">{{ `app.no_data`|trans }}</span>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex md6 xs12 d-flex>
          <v-card>
            <v-card-title class="pb-0">
              <v-layout align-center justify-space-between fill-height>
                <v-flex xs8>
                  <h5 class="headline text-uppercase text-green">{{ 'app.patient_information.address' | trans }}</h5>
                </v-flex>
                <v-flex xs5>
                  <patient-manage-modal :edit-mode="true"/>
                </v-flex>
              </v-layout>
            </v-card-title>
            <v-card-text class="pt-0">
              <v-divider></v-divider>
              <v-layout wrap>
                <v-flex xs4>
                  <h5 class="subheading">{{ 'app.street'|trans }}</h5>
                  <span>{{ patient.street }}</span>
                  <span v-if="patient.street === null">{{ `app.no_data`|trans }}</span>
                </v-flex>
                <v-flex xs4>
                  <h5 class="subheading">{{ 'app.building_number'|trans }}</h5>
                  <span>{{ patient.building_number }}</span>
                  <span v-if="patient.building_number === null">{{ `app.no_data`|trans }}</span>
                </v-flex>
                <v-flex xs4>
                  <h5 class="subheading">{{ 'app.apartment_number'|trans }}</h5>
                  <span>{{ patient.apartment_number }}</span>
                  <span v-if="patient.apartment_number === null"  >{{ `app.no_data`|trans }}</span>
                </v-flex>
                <v-flex xs6>
                  <h5 class="mt-4 subheading">{{ 'app.postal_code'|trans }}</h5>
                  <span>{{ patient.postal_code }}</span>
                  <span v-if="patient.postal_code === null">{{ `app.no_data`|trans }}</span>
                </v-flex>
                <v-flex xs6>
                  <h5 class="mt-4 subheading">{{ 'app.city'|trans }}</h5>
                  <span>{{ patient.city }}</span>
                  <span v-if="patient.city === null">{{ `app.no_data`|trans }}</span>
                </v-flex>
                <v-flex xs6>
                  <h5 class="mt-4 subheading">{{ 'app.state'|trans }}</h5>
                  <span>{{ getVoivodeshipName() }}</span>
                  <span v-if="!patient.state">{{ `app.no_data`|trans }}</span>
                </v-flex>
                <v-flex xs6>
                  <h5 class="mt-4 subheading">{{ 'app.country'|trans }}</h5>
                  <span>{{ patient.country }}</span>
                  <span v-if="patient.country === null">{{ `app.no_data`|trans }}</span>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import {trans} from "../../../app";
import { mapGetters} from "vuex";
import VoivodeshipService from "../../../services/VoivodeshipService";
import {polishPlurals} from "polish-plurals";

export default {
  data: function () {
    return {
      patientService: null,
    }
  },

  methods: {
    getSex() {
      return this.patient.sex ? trans(`app.${this.patient.sex}`) : '';
    },
    getVoivodeshipName() {
      const stateId = this.patient.state;
      const state = new VoivodeshipService().getAll().find(voivodeship => voivodeship.id === stateId);

      return !!state ? state.name : '';
    },
    getAge(age) {
      return polishPlurals(trans('app.year'), trans('app.years'), trans('app.years_genitive'), age);
    }
  },
  computed: {
    ...mapGetters(['patient'])
  },
}
</script>

<style scoped>

</style>
